
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@/components/ui/card';
import CustomerBasicInfo from './CustomerBasicInfo';
import CustomerAddressInfo from './CustomerAddressInfo';
import CustomerFormActions from './CustomerFormActions';

interface CustomerInfoTabProps {
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  phone: string;
  setPhone: (phone: string) => void;
  address: string;
  setAddress: (address: string) => void;
  country: string;
  setCountry: (country: string) => void;
  region: string;
  setRegion: (region: string) => void;
  municipality: string;
  setMunicipality: (municipality: string) => void;
  errors: Record<string, string>;
  saving: boolean;
  onBack: () => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
}

const CustomerInfoTab = ({
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  address,
  setAddress,
  country,
  setCountry,
  region,
  setRegion,
  municipality,
  setMunicipality,
  errors,
  saving,
  onBack,
  handleSubmit
}: CustomerInfoTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informations du client</CardTitle>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent className="space-y-4">
          <CustomerBasicInfo
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            phone={phone}
            setPhone={setPhone}
            errors={errors}
            saving={saving}
          />
          
          <CustomerAddressInfo
            address={address}
            setAddress={setAddress}
            country={country}
            setCountry={setCountry}
            region={region}
            setRegion={setRegion}
            municipality={municipality}
            setMunicipality={setMunicipality}
            saving={saving}
          />
        </CardContent>

        <CardFooter>
          <CustomerFormActions onBack={onBack} saving={saving} />
        </CardFooter>
      </form>
    </Card>
  );
};

export default CustomerInfoTab;
